import { List, ListItem } from "@mui/material";
import React from "react";
import { contactDetailsData } from "../../constants";
import Gene20Box from "../Gene20Box/Gene20Box";
const MobileContacts = () => {
  return (
    <Gene20Box
      sx={{
        display: "flex",
        justifyContent: "right",
      }}
    >
      <List sx={{ display: "flex" }}>
        {contactDetailsData.map((item, key) => (
          <ListItem key={item.name} link={item.link} color="secondary">
            {item.component}
          </ListItem>
        ))}
      </List>
    </Gene20Box>
  );
};

export default MobileContacts;
